import { render, staticRenderFns } from "./MnpDialog.vue?vue&type=template&id=a0d978e2&"
import script from "./MnpDialog.vue?vue&type=script&lang=js&"
export * from "./MnpDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports